// Client/partner logos - pulled automatically from
// src/assets/images/clients/. Add more transparent-background logo
// files to that folder any time and they'll show up here.

function importAll(context) {
	return context.keys().sort().map((key) => context(key));
}

const clientLogos = importAll(
	require.context('@/assets/images/clients', false, /\.(png|svg)$/)
);

export default clientLogos;
